module.exports = __webpack_public_path__ + "img/coupon_20.66abc36c.png";